import { Navigate, Outlet } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../contexts/AuthContext'

// Skip auth in local development unless VITE_ENABLE_AUTH is set
const isLocalDev = import.meta.env.DEV &&
  !import.meta.env.VITE_ENABLE_AUTH &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')

export default function ProtectedRoute() {
  const { isAuthenticated, isLoading } = useAuth()
  const { t } = useTranslation('auth')

  // Always wait for auth to load - even in local dev, we want to respect
  // the user's session if they are logged in
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-surface">
        <div className="flex flex-col items-center gap-4">
          <svg className="animate-spin h-8 w-8 text-primary" viewBox="0 0 24 24">
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
              fill="none"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
          </svg>
          <span className="text-text-secondary">{t('loading')}</span>
        </div>
      </div>
    )
  }

  // In local dev, allow unauthenticated access (debug-user mode)
  // In production, require authentication
  if (!isAuthenticated && !isLocalDev) {
    return <Navigate to="/login" replace />
  }

  return <Outlet />
}
